/*
 * Copyright (c) 2021.
 * Md Naimul Hasan
 * naim886@gmail.com
 * 01719123886
 * www.naimbd.com
 */
import React, {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import axios from "axios";
import BASEURL from "../../../Constants";
import loader from "../../../Assets/image/loader/ripple.svg";
import {Helmet} from "react-helmet";

const Truck = () => {
    const [trucks, setTruck] = useState([]);
    const [isLoading, setIsLoading] = useState(false)

    const getTruck = () => {
        setIsLoading(true)
        axios.get(BASEURL + '/api/dashboard/truck').then(res => {
            setTruck(res.data)
            setIsLoading(false)
        })
    }
    useEffect(() => {
        getTruck()
    }, [])
    return (
        <main>
            <Helmet>
                <title>Truck List | Dashboard | Mega Hot Mop</title>
            </Helmet>
            <div className="container-fluid px-4">
                <h1 className="mt-4">Truck List</h1>
                <ol className="breadcrumb mb-4">
                    <li className="breadcrumb-item"><Link to={'/'}>Dashboard</Link></li>
                    <li className="breadcrumb-item active">Truck List</li>
                </ol>
                <div className="row">
                    <div className="col-md-12">
                        <div className="my-card card p-2">
                            <table className={'table table-hover table-bordered'}>
                                <thead>
                                <tr>
                                    <th>SL</th>
                                    <th>Truck Name</th>
                                    <th>Truck Number</th>
                                </tr>
                                </thead>
                                <tbody>
                                {trucks.map((truck, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{truck.name}</td>
                                        <td>{truck.truck_number}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                            {isLoading ?
                                <div className="loader">
                                    <img src={loader} alt={'Loader'}/>
                                </div> : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Truck;

